import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ScrollTools from "@/components/feature/ScrollTools";
import { useSeo } from "@/hooks/useSeo";
import { brand, faqs } from "@/mocks/site";
import { cases } from "@/mocks/cases";
import HeroSection from "@/pages/home/components/HeroSection";
import AnchorNav from "@/pages/home/components/AnchorNav";
import WindSection from "@/pages/home/components/WindSection";
import FocusSection from "@/pages/home/components/FocusSection";
import PicksSection from "@/pages/home/components/PicksSection";
import MethodSection from "@/pages/home/components/MethodSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubmitSection from "@/pages/home/components/SubmitSection";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: brand.name,
    alternateName: brand.suffix,
    url: "https://stranding.cn/",
    description: brand.intro,
    email: brand.email,
    foundingDate: "2021",
    knowsAbout: ["舆论反转", "信息核验", "媒介素养", "证据等级"],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: brand.name,
    url: "https://stranding.cn/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://stranding.cn/cases?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "瓜田黑料｜反转剧情梳理与双方回应汇总观察站",
    url: "https://stranding.cn/",
    description:
      "聚焦争议焦点与反转剧情，提供双方回应、舆论风向、洗白分析与澄清汇总，帮你理清每场风波的前因后果。",
    isPartOf: { "@type": "WebSite", url: "https://stranding.cn/" },
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "重点反转案例精选",
    itemListElement: cases.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `https://stranding.cn/cases/${item.slug}`,
      name: item.title,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "瓜田黑料｜反转剧情梳理与双方回应汇总观察站",
    description:
      "瓜田黑料专注梳理每场网络风波的反转剧情与双方回应，提供舆论风向变化、洗白分析、澄清汇总与正序时间线，帮你看清事件前因后果与信息如何转向。",
    keywords: "瓜田黑料,反转剧情,双方回应,舆论风向,澄清汇总,洗白分析",
    path: "/",
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20desk%20flatlay%20with%20folded%20newspapers%2C%20magnifier%20and%20amber%20highlighter%20arranged%20in%20a%20clean%20grid%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight&width=1200&height=630&seq=guatian-og-home&orientation=landscape",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <AnchorNav />
        <WindSection />
        <FocusSection />
        <PicksSection />
        <MethodSection />
        <FaqSection />
        <SubmitSection />
      </main>
      <SiteFooter />
      <ScrollTools />
    </div>
  );
}